import "./MenuBar.css";
import globalContext from "../../Contexts/GlobalContext";

import React, { useContext, useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

import { IoClose } from "react-icons/io5";
import { BiCar } from "react-icons/bi";
import { RiProfileLine } from "react-icons/ri";
import { GiCarKey } from "react-icons/gi";
import { IoExitOutline } from "react-icons/io5";
import { BsPersonBadge } from "react-icons/bs";
import { HiOutlineWrenchScrewdriver } from "react-icons/hi2";
import MessageModals from "../modals/MessageModals";

export default function MenuBar({ isMenuBarOpen, setIsMenuBarOpen }) {
  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies();

  const box1 = useRef();
  const box2 = useRef();
  const box3 = useRef();
  const box4 = useRef();
  const menubarContainer = useRef();
  useEffect(() => {
    if (isMenuBarOpen === "true") {
      menubarContainer?.current?.classList?.remove("outMenu");
      menubarContainer?.current?.classList?.add("inMenu");
    } else if (isMenuBarOpen === "false") {
      menubarContainer?.current?.classList?.remove("inMenu");
      menubarContainer?.current?.classList?.add("outMenu");
      setTimeout(() => {
        setIsMenuBarOpen("");
      }, 500);
    } else {
    }
  }, [isMenuBarOpen]);
  const contextData = useContext(globalContext);

  return (
    <>
      <div
        className={`absolute  w-[100vw] h-screen z-[10000] backdrop-blur-sm ${
          isMenuBarOpen === "true" ? "block" : "hidden"
        }`}
      ></div>

      <div
        ref={menubarContainer}
        className={`fixed w-[80vw] h-full top-0 -right-[100vw] flex flex-col items-center justify-between bg-color-primary-B py-[5.483490566037736vw] gap-y-[5vw] z-[10000] overflow-scroll ${
          isMenuBarOpen === "true" ? "block" : ""
        }`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="w-full flex flex-col items-center justify-items-start">
          <div className="w-full flex items-center justify-between mb-[4vw] px-[5.542452830188679vw]">
            <div className="w-[20vw] ">
              <svg
                width="20vw"
                viewBox="0 0 239 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M191.805 47.6372V14.5252C191.805 13.6523 192.213 12.8958 192.969 12.4884C193.726 12.0229 194.598 12.0229 195.355 12.4884C196.053 12.8958 196.519 13.6523 196.519 14.5252V47.6372C196.519 48.2773 196.286 48.8593 195.821 49.3248C195.413 49.7322 194.773 49.9649 194.133 49.9649C192.853 49.9649 191.805 48.9175 191.805 47.6372Z"
                  fill="#F8F8F3"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M178.77 12.1393H153.921C153.048 12.1393 152.292 12.6048 151.885 13.3031C151.477 14.0597 151.477 14.9326 151.885 15.6891C152.292 16.4456 153.048 16.9111 153.921 16.9111H176.384C178.537 16.9111 180.458 18.0168 181.505 19.8208C182.552 21.683 182.552 23.8943 181.505 25.7565C180.458 27.5605 178.537 28.7244 176.384 28.7244H155.143C154.212 28.7244 153.281 29.0735 152.583 29.7719C151.943 30.412 151.535 31.2849 151.535 32.2742V46.4733C151.535 47.4044 151.943 48.2773 152.583 48.9757C153.281 49.6158 154.212 49.9649 155.143 49.9649H159.857C160.788 49.9649 161.661 49.6158 162.359 48.9757C163 48.2773 163.407 47.4044 163.407 46.4733V39.3738C163.407 38.6754 163.931 38.1517 164.571 38.1517H178.77C184.647 38.1517 189.419 33.438 189.419 27.5023V22.7887C189.419 16.9111 184.647 12.1393 178.77 12.1393Z"
                  fill="#F8F8F3"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M136.172 12.1393H111.324C110.509 12.1393 109.694 12.6048 109.287 13.3031C108.88 14.0597 108.88 14.9326 109.287 15.6891C109.694 16.4456 110.509 16.9111 111.324 16.9111H133.786C135.94 16.9111 137.86 18.0168 138.907 19.8208C140.013 21.683 140.013 23.8943 138.907 25.7565C137.86 27.5605 135.94 28.7244 133.786 28.7244H119.064C117.609 28.7244 116.328 29.5391 115.747 30.8775C115.223 32.216 115.514 33.729 116.561 34.7765L129.771 47.9864C129.888 48.1028 130.004 48.2191 130.12 48.3355C130.237 48.4519 130.411 48.5101 130.528 48.6265C130.702 48.7429 130.935 48.8593 131.11 48.9757C131.401 49.1502 131.692 49.3248 132.041 49.4412C132.332 49.5576 132.681 49.674 132.972 49.7904C133.205 49.8486 133.379 49.9067 133.612 49.9067C133.786 49.9067 133.961 49.9649 134.136 49.9649C134.31 49.9649 134.485 49.9649 134.659 49.9649H143.272C143.388 49.9649 143.447 49.9649 143.563 49.9649C143.679 49.9649 143.738 49.9649 143.854 49.9649C143.97 49.9067 144.028 49.9067 144.145 49.9067C144.261 49.8486 144.319 49.8486 144.436 49.7904C144.494 49.7904 144.61 49.7322 144.669 49.674C144.785 49.6158 144.843 49.5576 144.96 49.4994C144.96 49.4994 145.018 49.4412 145.076 49.383C145.076 49.383 145.134 49.383 145.134 49.3248C145.251 49.2084 145.309 49.1502 145.367 49.0339C145.425 48.9757 145.483 48.8593 145.542 48.8011C145.542 48.6847 145.6 48.5683 145.6 48.4519C145.658 48.3355 145.658 48.2191 145.658 48.161C145.658 48.1028 145.658 48.0446 145.658 47.9864C145.658 47.9282 145.658 47.87 145.658 47.8118C145.6 47.6954 145.6 47.6372 145.6 47.5208C145.542 47.4626 145.542 47.3462 145.483 47.2299C145.425 47.1717 145.425 47.1135 145.367 46.9971C145.309 46.9389 145.251 46.8225 145.192 46.7061C145.134 46.6479 145.076 46.5897 145.018 46.5315C144.96 46.4733 144.901 46.357 144.785 46.2988L138.326 39.7811C138.035 39.4901 137.918 39.0828 138.035 38.6754C138.151 38.2681 138.442 37.9771 138.849 37.8607C143.563 36.6387 146.822 32.3906 146.822 27.5023V22.7887C146.822 16.9111 142.05 12.1393 136.172 12.1393Z"
                  fill="#153038"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M77.7463 12.1393H50.861C48.0095 12.1393 45.3326 13.245 43.2958 15.2817C41.3173 17.2603 40.2116 19.9372 40.2116 22.7887V39.3738C40.2116 42.167 41.3173 44.9021 43.2958 46.8807C45.3326 48.8593 48.0095 49.9649 50.861 49.9649H62.6742C65.5257 49.9649 68.2026 48.8593 70.2393 46.8807L95.4952 21.6248H95.9608C97.532 21.6248 99.045 22.2067 100.151 23.3124C101.256 24.4181 101.897 25.9893 101.897 27.5023V32.8561H95.8444C94.6223 32.8561 93.4585 33.4962 92.8184 34.6019C92.1782 35.7076 92.1782 37.046 92.8184 38.1517C93.4585 39.2574 94.6223 39.9557 95.8444 39.9557H101.897V46.4733C101.897 48.3937 103.468 49.9649 105.446 49.9649C107.367 49.9649 108.996 48.3937 108.996 46.4733V22.7887C108.996 19.9372 107.832 17.2603 105.854 15.2817C103.875 13.245 101.14 12.1393 98.3467 12.1393H91.6545C89.4431 12.1393 87.3482 13.0122 85.777 14.5834L62.2669 38.0935C60.6956 39.6647 58.6007 40.5376 56.3893 40.5376H53.2469C49.9299 40.5376 47.3112 37.9189 47.3112 34.6019V22.7887C47.3112 19.5298 49.9299 16.9111 53.2469 16.9111H77.7463C79.0847 16.9111 80.1322 15.8055 80.1322 14.5252C80.1322 13.1868 79.0847 12.1393 77.7463 12.1393Z"
                  fill="#153038"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M26.6525 32.2742H8.26345C6.1103 32.2742 3.95715 31.4013 2.44412 29.8301C0.8729 28.317 0 26.1639 0 23.9525V22.7887C0 19.9372 1.10567 17.2603 3.14244 15.2817C5.12101 13.245 7.8561 12.1393 10.6494 12.1393H35.4979C36.3126 12.1393 37.1273 12.6048 37.5347 13.3031C38.0002 14.0597 38.0002 14.9326 37.5347 15.6891C37.1273 16.4456 36.3126 16.9111 35.4979 16.9111H11.2313C9.77648 16.9111 8.37984 17.6676 7.62333 18.9479C6.92501 20.2282 6.92501 21.7994 7.62333 23.0796C8.37984 24.3599 9.77648 25.1746 11.2313 25.1746H29.5622C31.7736 25.1746 33.8685 26.0475 35.4397 27.5605C36.9528 29.1317 37.8839 31.2267 37.8839 33.438V39.3738C37.8839 42.167 36.72 44.9021 34.7414 46.8807C32.7628 48.8593 30.0278 49.9649 27.2345 49.9649H4.71366C3.4916 49.9649 2.26954 49.4994 1.39664 48.6265C0.52374 47.6954 0 46.5315 0 45.2513C0 42.6326 2.15315 40.5376 4.71366 40.5376H26.6525C28.9221 40.5376 30.7261 38.6754 30.7261 36.4059C30.7261 34.0782 28.9221 32.2742 26.6525 32.2742Z"
                  fill="#153038"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M239 41.4105C239 46.1242 235.101 49.9649 230.387 49.9649H226.721C224.452 49.9649 222.473 48.7429 221.309 46.7643L208.914 25.4656C208.565 24.8836 207.867 24.5345 207.168 24.709C206.47 24.8836 206.004 25.4656 206.004 26.1639V46.4733C206.004 48.3937 204.433 49.9649 202.455 49.9649C201.523 49.9649 200.651 49.6158 200.01 48.9757C199.312 48.2773 198.963 47.4044 198.963 46.4733V20.7519C198.963 18.4824 199.836 16.271 201.465 14.6998C203.095 13.0704 205.248 12.1393 207.517 12.1393H211.242C213.453 12.1393 215.432 13.4195 216.596 15.3399L229.049 36.6969C229.34 37.2788 230.038 37.628 230.737 37.4534C231.435 37.2788 231.9 36.6969 231.9 35.9404V15.6891C231.9 14.758 232.308 13.8269 232.948 13.1868C233.588 12.4884 234.519 12.1393 235.45 12.1393C237.371 12.1393 239 13.7105 239 15.6891V41.4105Z"
                  fill="#F8F8F3"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M193.551 44.4947V10.1025H193.26H188.255C188.314 8.64765 188.954 7.3092 189.943 6.26172L190.059 6.20353V1.72264H188.488V0.0350342H199.72V1.72264H198.148V6.14533L198.265 6.26172C199.312 7.25101 199.952 8.64765 200.069 10.1025H195.006H194.715V44.4947C194.715 45.2513 194.657 45.8914 194.54 46.4151C194.424 46.8807 194.308 47.1716 194.133 47.1716C193.842 47.1716 193.551 45.9496 193.551 44.4947Z"
                  fill="#153038"
                />
              </svg>
            </div>

            <IoClose
              className="w-[4vw] h-[4vw]"
              onClick={() => {
                setIsMenuBarOpen("false");
              }}
            />
          </div>
          <div className="w-full gap-y-[2vw] flex flex-col items-center justify-start overflow-y-auto px-[5.542452830188679vw]">
            {window.location.pathname !== "/add-car" &&
              cookies?.plate?.length >= 8 && (
                <div className="w-full flex items-center justify-between text-[4vw] text-[#000000] font-font_primary_A z-[1000] ">
                  <div
                    ref={box1}
                    className="relative border-[1px] rounded-[1.8vw] border-[#474747] w-full h-[15vw] flex items-center justify-between px-[4vw]"
                    onClick={() => {
                      if (window.location.pathname === "/servicePlace") {
                        setIsMenuBarOpen("false");
                      } else {
                        navigate("/servicePlace");
                      }
                    }}
                  >
                    <span className=" font-font_primary_A text-[3vw] ">
                      سرویس خودرو در محل
                    </span>

                    <img
                      src="../assets/images/menubar/Car_assistance.svg"
                      alt=""
                      className="w-[10vw]"
                    />
                  </div>
                </div>
              )}
            {window.location.pathname !== "/add-car" &&
              cookies?.plate?.length >= 8 && (
                <div className="w-full  flex items-center justify-between text-[4vw] text-[#000000] font-font_primary_A z-[1000] ">
                  <div
                    ref={box2}
                    className="relative border-[1px] rounded-[1.8vw] border-[#474747] w-full h-[15vw] flex items-center justify-between px-[4vw] "
                    onClick={() => {
                      if (window.location.pathname === "/insuranceList") {
                        setIsMenuBarOpen("false");
                      } else {
                        navigate("/insuranceList");
                      }
                    }}
                  >
                    <span className="font-normal text-[3vw]">
                      خدمات بیمه خودرو
                    </span>

                    <img
                      src="../assets/images/menubar/Insurance.svg"
                      alt=""
                      className="w-[10vw]"
                    />
                  </div>
                </div>
              )}

            {window.location.pathname !== "/add-car" &&
              cookies?.plate?.length >= 8 && (
                <div className="w-full  flex items-center justify-between text-[4vw] text-[#000000] font-font_primary_A z-[1000] ">
                  <div
                    ref={box3}
                    className="relative border-[1px] rounded-[1.8vw] border-[#474747] w-full h-[15vw] flex items-center justify-between px-[4vw]"
                    onClick={() => {
                      navigate("/payEst");
                    }}
                  >
                    <span className="font-normal text-[3vw]">
                      خدمات پرداختی خودرو
                    </span>

                    <img
                      src="../assets/images/menubar/payment_service.svg"
                      alt=""
                      className="w-[10vw]"
                    />
                  </div>
                </div>
              )}

            {window.location.pathname !== "/add-car" &&
              cookies?.plate?.length >= 8 && (
                <div className="w-full flex items-center justify-between text-[4vw] text-[#000000] font-font_primary_A z-[1000] ">
                  <div
                    ref={box4}
                    className="relative border-[1px] rounded-[1.8vw] border-[#474747] w-full h-[15vw] flex items-center justify-between px-[4vw]"
                    onClick={() => {
                      navigate("/payEst");
                    }}
                  >
                    <span className="font-normal text-[3vw]">
                      خدمات استعلامی
                    </span>

                    <img
                      src="../assets/images/menubar/estelam_service.svg"
                      alt=""
                      className="w-[10vw]"
                    />
                  </div>
                </div>
              )}

            {window.location.pathname !== "/profile" && (
              <div
                className={`w-full flex items-center justify-between text-[3.5vw] text-[#000000] font-font_primary_A z-[1000] font-normal pr-[1vw] border-b-[1px] border-[#b69a20] pb-[2vw] ${
                  window.location.pathname !== "/add-car" &&
                  cookies?.plate?.length >= 8
                    ? "mt-[8vw]"
                    : ""
                }`}
                onClick={() => {
                  navigate("/profile");
                }}
              >
                <div className="w-full flex items-center justify-start gap-x-2">
                  <RiProfileLine className="w-[4vw] h-[4vw]" color="#153038" />
                  <p>پروفایل من</p>
                </div>
              </div>
            )}
            {window.location.pathname !== "/add-car" && (
              <div
                className={`w-full flex items-center justify-between text-[3.5vw] text-[#000000] font-font_primary_A z-[1000] font-normal pr-[1vw] border-b-[1px] border-[#b69a20] pb-[2vw] ${
                  window.location.pathname === "/profile" ? "mt-[8vw]" : ""
                }`}
                onClick={() => {
                  navigate("/add-car");
                }}
              >
                <div className="w-full flex items-center justify-start gap-x-2">
                  <GiCarKey className="w-[4vw] h-[4vw]" color="#153038" />
                  <p>خودروهای من</p>
                </div>
              </div>
            )}
            {window.location.pathname !== "/add-car" &&
              window.location.pathname !== "/add-car-details" &&
              cookies?.plate?.length >= 8 && (
                <div
                  className="w-full flex items-center justify-between text-[3.5vw] text-[#000000] font-font_primary_A font-normal z-[1000] pr-[1vw] border-b-[1px] border-[#b69a20] pb-[2vw]"
                  onClick={() => {
                    navigate("/car-details");
                  }}
                >
                  <div className="w-full flex items-center justify-start gap-x-2">
                    <BiCar className="w-[4vw] h-[4vw]" color="#153038" />
                    <p>مشخصات خودرو</p>
                  </div>
                </div>
              )}
            <div
              className="w-full flex items-center justify-between text-[3.5vw] text-[#000000] font-font_primary_A font-normal z-[1000] pr-[1vw] border-b-[1px] border-[#b69a20] pb-[2vw]"
              onClick={() => {
                navigate("/invite");
              }}
            >
              <div className="w-full flex items-center justify-start gap-x-2">
                <BsPersonBadge className="w-[4vw] h-[4vw]" color="#153038" />
                <p>دعوت از دوستان</p>
              </div>
            </div>
            <div
              className="w-full flex items-center justify-between text-[3.5vw] text-[#000000] font-font_primary_A font-normal z-[1000] pr-[1vw] border-b-[1px] border-[#b69a20] pb-[2vw]"
              onClick={() => {
                setIsMenuBarOpen("false");
                contextData.setIsToastOpen(true);
                contextData.setToastMessage(
                  "این قابلیت به زودی راه‌اندازی می‌گردد."
                );
              }}
            >
              <div className="w-full flex items-center justify-start gap-x-2">
                <HiOutlineWrenchScrewdriver
                  className="w-[4vw] h-[4vw]"
                  color="#153038"
                />
                <p>اتو سرویس‌های اطراف من</p>
              </div>
              <span className="w-auto h-auto px-[2vw] py-[0.75vw] text-[2vw] rounded-[1.2vw] bg-[#153038] text-[#FFF] singleLine">
                به زودی
              </span>
            </div>
            <div
              className="w-full flex items-center justify-between text-[3.5vw] text-[#000000] font-font_primary_A font-normal z-[2000] pr-[1vw]"
              onClick={() => {
                setIsMenuBarOpen("false");
                contextData.setIsExitModalOpen(true);
              }}
            >
              <div className="w-full flex items-center justify-start gap-x-2">
                <IoExitOutline className="w-[4vw] h-[4vw]" color="#153038" />
                <p>خروج از حساب کاربری</p>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex items-center justify-between px-[5.542452830188679vw]">
          <div
            className="flex items-center justify-center gap-x-[2vw]"
            onClick={() => {
              setIsMenuBarOpen("false");
              navigate("/contactus");
            }}
          >
            <img
              src="../assets/images/menubar/sup.svg"
              alt=""
              className="w-[7vw]"
            />
            <p className="text-[3.5vw] text-black font-font_primary_A font-semibold">
              پشتیبانی
            </p>
          </div>
          <div className="flex items-center justify-center gap-x-[2vw]">
            <a href="https://eitaa.com/ScarpinChannel" target="_blank">
              <img
                src="../assets/images/menubar/eita.svg"
                alt=""
                className="w-[5vw]"
              />
            </a>
            <a href="https://t.me/scarpinChannel" target="_blank">
              <img
                src="../assets/images/menubar/tel.svg"
                alt=""
                className="w-[5vw]"
              />
            </a>
            <a
              href="https://instagram.com/scarpin.ir?igshid=YmMyMTA2M2Y"
              target="_blank"
            >
              <img
                src="../assets/images/menubar/insta.svg"
                alt=""
                className="w-[5vw]"
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
